export const banks = {
  'kb-dolinsk': 'КБ Долинск',
  mtcbank: 'МТС Банк',
  mkb: 'МКБ',
  ozon: 'Озон',
  humo: 'Humo',
  'capital-bank': 'Капиталбанк',
  'hankor-bank': 'ХанкорБанк',
  'anor-bank': 'Анорбанк',
  hamkorbank: 'Hamkorbank',
  awn: 'awn',
  'iturup-bank': 'ИТУРУП',
  'ubrr-bank': 'Убрир',
  nbt: 'НБТ',
  bgfbank: 'Бжф банк',
  spitamenbank: 'Спитамен Банк',
  rnkb: 'РНКБ',
  klookva: 'Клюква банк',
  'any-bank': 'Любой банк',
  'alfa-bank': 'Альфа-банк',
  atb: 'АТБ',
  realistbank: 'Реалист Банк',
  'jusan-bank': 'Jusan Bank',
  'mts-dengi': 'МТС Деньги',
  amonatbank: 'Амонатбанк',
  mbank: 'МБанк',
  dushanbe: 'Душанбе Сити Банк',
  'alif-bank': 'Алиф Банк',
  'million-bank': 'Миллионбанк',
  'kaspi-bank': 'Каспи Банк',
  'expo-bank': 'Экспобанк',
  idbank: 'IDBank',
  'russkiy-standart': 'Русский Стандарт',
  'akb-primorie': 'АКБ Приморье',
  uralsib: 'Уралсиб',
  albank: 'Алмазэргиэнбанк',
  tinkoff: 'Тинькофф',
  universal: 'АКБ Универсал',
  solidarnost: 'Солидарность',
  rencredit: 'Ренессанс банк',
  novikom: 'Новиком',
  bcs: 'БКС',
  yandex: 'Яндекс Банк',
  sberbank: 'Сбербанк',
  chelindbank: 'Челиндбанк',
  chelyabinvest: 'Челябинвест',
  zenit: 'Зенит Банк',
  m10: 'М10',
  energobank: 'Энергобанк',
  mts: 'МТС',
  avangard: 'Авангард Банк',
  norvik: 'Норвик Банк',
  bereke: 'Береке',
  'bgf-bank': 'БЖФ Банк',
  ktb: 'КТБ',
  gazprombank: 'Газпромбанк',
  eskhata: 'eskhata',
  bkash: 'bKash',
  '1cupis': 'ЦУПИС',
  promsvyazbank: 'Промсвязьбанк',
  sbp: 'СБП',
  umani: 'Юмани',
  ingobank: 'Ингострах банк',
  primsocbank: 'Примсоцбанк',
  euroalliance: 'Евроальянс банк',
  kontur: 'Контур банк',
  apra: 'Апра банк',
  ibt: 'ИБТ',
  loco: 'Локо Банк',
  avito: 'Авито',
  kazan: 'Банк Казани',
  otp: 'ОТП',
  'akb-lanta-bank': 'АКБ Ланта-Банк',
  'svoi-bank': 'Свой банк',
  'nbko-vasl': 'НБКО Васл',
  genbank: 'Генбанк',
  rosselkhozbank: 'Россельхозбанк',
  'ubrir-bank': 'Убрир банк',
  nokssbank: 'Нокссбанк',
  cbr: 'ЦБР',
  vtb: 'ВТБ',
  'fora-bank': 'Фора-Банк',
  intesa: 'Интеза банк',
  wildberries: 'Вайлдбериз',
  sinara: 'Синара Банк',
  bspb: 'Банк Санкт-Петербург',
  kubankredit: 'Кубань Кредит',
  unistream: 'Юнистрим Банк',
  rayfayzen: 'Райфайзен',
  sovkobank: 'Совкомбанк',
  'tsifra-bank': 'Цифра банк',
  levoberezhny: 'Левобережный',
  luchi: 'Лучи',
  akbars: 'Ак Барс',
  tkbbank: 'ТКБ Банк',
  abrussia: 'АБ Россия',
  pochtabank: 'Почта Банк',
  domrf: 'Дом РФ',
}
